var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as ReviewFactory from "../../classes/definitions/product/review";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import ReviewsList from '../../components/Reviews/ReviewsList/ReviewsList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./ReviewsReduxProps";
var Reviews = /** @class */ (function (_super) {
    __extends(Reviews, _super);
    function Reviews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.parentId = '-1';
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllReviews = function (page) {
            if (_this.parentId !== '-1') {
                _this.api.getReviews(_this.parentId, page)
                    .then(function (response) {
                    var values = ReviewFactory.createReviews(response.data);
                    var meta = _.get(response, 'data.meta', null);
                    _this.setState({ data: values, meta: meta });
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.messages, 'Не можахме да заредим отзива.', _this.props.history);
                });
            }
            else {
                _this.api.getUnapprovedReviews(page)
                    .then(function (response) {
                    var values = ReviewFactory.createReviews(response.data);
                    var meta = _.get(response, 'data.meta', null);
                    _this.setState({ data: values, meta: meta });
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.messages, 'Не можахме да заредим отзива.', _this.props.history);
                });
            }
        };
        _this.toEditReview = function (selectedId) {
            if (selectedId !== '-1') {
                if (_this.parentId !== '-1') {
                    _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId + AppRoutes.review.path + ("/" + selectedId));
                }
                else {
                    _this.props.history.push(AppRoutes.review.path + ("/" + selectedId));
                }
            }
        };
        _this.toParentProduct = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    Reviews.prototype.componentDidMount = function () {
        this.parentId = _.get(this.props, 'match.params.id', '-1');
        this.getAllReviews(1);
    };
    Reviews.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041E\u0442\u0437\u0438\u0432\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions justify-content-end" }, this.parentId !== '-1' ? React.createElement("a", { onClick: this.toParentProduct },
                            React.createElement("i", { className: "fa fa-backward" }),
                            " \u041D\u0430\u0437\u0430\u0434") : null),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(ReviewsList, { gridData: data, edit: this.toEditReview, messages: this.messages, deleteItem: this.deleteItem, meta: meta, getAllReviews: this.getAllReviews }))))));
    };
    return Reviews;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(Reviews);



//////////////////
// WEBPACK FOOTER
// ./src/views/Reviews/Reviews.tsx
// module id = 437
// module chunks = 0